// @ts-nocheck
export default defineNuxtPlugin(() => {
  const { $lang } = useNuxtApp()

  setTimeout(() => {
    if ($lang !== 'de') { return }
    const _tsid = 'X6CE93F3F341393A17CE8B7933C9674E7'
    window._tsConfig = {
      yOffset: '0' /* offset from page bottom */,
      variant: 'custom_reviews' /* default, reviews, custom, custom_reviews */,
      customElementId:
          'trustBadge' /* required for variants custom and custom_reviews */,
      trustcardDirection:
          'bottomLeft' /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */,
      customBadgeWidth: '' /* for custom variants: 40 - 90 (in pixels) */,
      customBadgeHeight: '' /* for custom variants: 40 - 90 (in pixels) */,
      disableResponsive: 'false' /* deactivate responsive behaviour */,
      disableTrustbadge: 'false' /* deactivate trustbadge */,
      responsive: {
        variant: 'floating_reviews'
      },
      customCheckoutElementId: 'customCheckoutDiv'
    }
    useHead({
      script: [
        {
          src: '//widgets.trustedshops.com/js/' + _tsid + '.js',
          async: true,
          type: 'text/javascript'
        }
      ]
    })
  }, 1000)
})
